export default "__VITE_ASSET__CP93Iivm__"